//import Libraries
import React, { Component } from 'react';
import {connect} from 'react-redux';


import * as accountActions from './actions/accountActions'; 

//import Components


import './Account.css'

class Account extends Component {

    constructor(props) {
        super(props);

        this.state = {
            approved : this.props.account.approved === undefined ? false : this.props.account.approved
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if(prevState.approved !== this.state.approved) {
            this.props.onUpdateAccountApproved(this.props.account.uid, this.state.approved);
        }
    }

    handleOnChange = (e) => {
        this.setState({
            approved : !this.state.approved
        })
    }

    render() {
        const {fullName, company, phone, address, orders, greenhouseType, plantType, areaSize, approved} = this.props.account;

        return (
            <tr>
                <td> {fullName} </td>
                <td> {company} </td>
                <td> {phone} </td>
                <td> {orders ? Array.isArray(orders) ? orders.length : 1 : 0 } </td>
                <td> {address} </td>
                <td> {greenhouseType} </td>
                <td> {plantType} </td>
                <td> {areaSize} </td>
                <td> <input type="checkbox" value={this.state.approved} onChange={this.handleOnChange} defaultChecked={this.state.approved}/></td>
            </tr>
        );
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        onUpdateAccountApproved : (id, value) => {
            dispatch(accountActions.updateAccountApproved(id, value));
        },
    }
}

export default connect(null, mapDispatchToProps)(Account);



// WEBPACK FOOTER //
// ./src/pages/Admin/AccountManager/Account.js